import Schema from 'AppReact/schema';
import { unitMin, minAdmin, tenant, assignTech } from 'types';
import { assignedPerson } from '../assignedToBoxDropdown/internalState';

export default {
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),


  selectedInspectionStatuses: Schema('integer', 'array', { defaultValue: [] }),
  selectedUnitIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedAssignedToIds: Schema('integer', 'array', { defaultValue: [] }),

  units: Schema(unitMin, 'array', { defaultValue: [] }),


  admins: Schema(minAdmin, 'array', { defaultValue: [] }),
  residents: Schema(tenant, 'array', { defaultValue: [] }),
  techs: Schema(assignTech, 'array', { defaultValue: [] }),

  assignedPersons: Schema(assignedPerson, 'array', { defaultValue: [] })
};
